import React, { FC, useMemo } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  MasterDetail,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import $createStore from 'utils/create-store-instance';

import { DetailTemplate } from './components';

const Shifts: FC = () => {
  const shiftDateSource: any = useMemo(() => $createStore('/v1/Shift/', 'id'), []);

  return (
    <div>
      <AppLayoutTop title="Смены"></AppLayoutTop>
      <AppCard>
        <DataGrid
          dataSource={shiftDateSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          keyExpr="id"
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="shift" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="number" caption="Номер смены" width={120} sortOrder="desc" />
          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="fullName" caption="Сотрудник" />
          <Column
            dataField="dateBegin"
            caption="Дата начала"
            dataType="date"
            cellRender={({ data }) => (
              <span>{data.dateBegin && moment(data.dateBegin).format('DD.MM.YYYY HH:mm')}</span>
            )}
          />
          <Column
            dataField="dateEnd"
            caption="Дата окончания"
            dataType="date"
            cellRender={({ data }) => <span>{data.dateEnd && moment(data.dateEnd).format('DD.MM.YYYY HH:mm')}</span>}
          />

          <Paging defaultPageSize={100} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />

          <MasterDetail enabled={true} component={DetailTemplate} />
          {/* <Export enabled={true} allowExportSelectedData={true} /> */}
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default Shifts;
